import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const NAV = [
  { to: "/receive", label: "Receive" },
  { to: "/become", label: "Become" },
  { to: "/events", label: "Events" },
  { to: "/lineage", label: "Lineage" },
  { to: "/contact", label: "Contact" },
];

const linkClass = ({ isActive }) =>
  [
    "font-sans font-light text-[0.72rem] tracking-[0.28em] uppercase",
    "transition-colors duration-300",
    isActive ? "text-gold" : "text-temple hover:text-gold",
  ].join(" ");

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="w-full bg-ivory border-b border-temple/10"
      data-testid="site-header"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-12 h-24 md:h-28 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-4 md:gap-5"
          aria-label="Shiva Murti Sacred Healing Arts — home"
          data-testid="header-wordmark"
        >
          <img
            src="/assets/shiva-murti-wheel.png"
            alt=""
            className="block h-16 md:h-20 w-auto"
          />
          <span className="block leading-tight">
            <span className="block font-serif font-light text-temple text-base md:text-lg tracking-[0.22em] uppercase">
              Shiva Murti
            </span>
            <span className="block font-sans font-light text-stone text-[0.6rem] md:text-[0.68rem] tracking-[0.28em] uppercase mt-1">
              Sacred Healing Arts
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10" data-testid="header-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={linkClass}
              data-testid={`nav-${item.label.toLowerCase()}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          className="md:hidden font-sans text-[0.72rem] tracking-[0.28em] uppercase text-temple"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls="mobile-nav"
          data-testid="mobile-menu-toggle"
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      {open && (
        <nav
          id="mobile-nav"
          className="md:hidden border-t border-temple/10 bg-ivory"
          data-testid="mobile-nav"
        >
          <ul className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={linkClass}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
};

export default Header;
